<template>
  <el-container>
    <el-aside>
      <!-- <aside-table :userinfo="userinfo" @active="active"></aside-table> -->
      <el-header>
        <el-input placeholder="请输入小区名字" v-model="likeData"></el-input>
        <el-button type="primary" @click="queryHousingList()">搜索</el-button>
      </el-header>
      <el-main class="aside-main">
        <el-table
          :data="tableData"
          :show-header="false"
          style="width:100%"
          ref="tablesure"
          highlight-current-row
          default-expand-all
          @row-click="houseClick"
          row-key="userId"
          :tree-props="{ children: 'users' }"
        >
          <el-table-column prop="userName"></el-table-column>
        </el-table>
      </el-main>
    </el-aside>
    <el-main class="channel-set-main">
      <h3>设置通道数据</h3>
      <!-- 通道设置 -->
      <div class="set-channel-relu">
        <div class="channel-set">
          <el-container>
            <h4>通道硬件</h4>
            <el-header>
              <el-select v-model="value" @change="getDrivewayInfo()">
                <el-option
                  v-for="(item, index) in channeloption"
                  :value="item.drivewayId"
                  :label="item.drivewayName"
                  :key="index"
                ></el-option>
              </el-select>
              <el-button type="primary" @click="addChannel()"
                >添加通道</el-button
              >
              <el-button type="warning" @click="changeChannel()"
                >修改通道</el-button
              >
              <el-button type="danger" @click="removeChannel()"
                >删除通道</el-button
              >
            </el-header>
            <el-main>
              <el-row>
                <el-col :span="6">通道名称：</el-col>
                <el-col :span="18">
                  <el-input
                    class="ipt-width"
                    v-model="passageway.drivewayName"
                    placeholder="请输入通道名称"
                  ></el-input>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="6">通道编码：</el-col>
                <el-col :span="18">
                  <el-input
                    class="ipt-width"
                    v-model="passageway.drivewayCode"
                    placeholder="请输入通道编码"
                  ></el-input>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="6">相机类型：</el-col>
                <el-col :span="18">
                  <el-select class="ipt-width" v-model="passageway.cameraType">
                    <el-option label="MXA180" value="1000"></el-option>
                    <el-option label="芊熠相机" value="2000"></el-option> 
                  </el-select>
                </el-col>
              </el-row>
              <!-- 选择部分 -->
              <el-collapse v-model="activeName" accordion class="set-collapse">
                <el-collapse-item title="入口相机" name="1">
                  <!-- 相机ip -->
                  <div class="c-i-marbot">
                    <div class="c-i-title">
                      相机IP：
                    </div>
                    <div>
                      <el-input 
                        placeholder="请输入相机IP"
                        class="ipt-width"
                        v-model="passageway.cameraIp"
                      ></el-input>
                    </div>
                  </div>
                  <div class="c-i-marbot">
                    <div class="c-i-title">
                      相机端口：
                    </div>
                    <div>
                      <el-input
                        placeholder="请输入相机端口"
                        class="ipt-width"
                        v-model="passageway.cameraPort"
                      ></el-input>
                    </div>
                  </div>
                </el-collapse-item>
                <el-collapse-item title="出口相机" name="2">
                  <div class="c-i-marbot">
                    <div class="c-i-title">
                      相机IP：
                    </div>
                    <div>
                      <el-input
                        placeholder="请输入相机IP"
                        class="ipt-width"
                        v-model="passageway.cameraOutIp"
                      ></el-input>
                    </div>
                  </div>
                  <div class="c-i-marbot">
                    <div class="c-i-title">
                      相机端口：
                    </div>
                    <div>
                      <el-input
                        placeholder="请输入相机端口"
                        class="ipt-width"
                        v-model="passageway.cameraOutPort"
                      ></el-input>
                    </div>
                  </div>
                </el-collapse-item>
                <el-collapse-item title="入口安卓机" name="3">
                  <div class="c-i-marbot">
                    <div class="c-i-title">
                      安卓机IP：
                    </div>
                    <div>
                      <el-input
                        placeholder="请输入安卓IP"
                        class="ipt-width"
                        v-model="passageway.androidIp"
                      ></el-input>
                    </div>
                  </div>
                  <div class="c-i-marbot">
                    <div class="c-i-title">
                      安卓端口：
                    </div>
                    <div>
                      <el-input
                        placeholder="请输入安卓端口"
                        class="ipt-width"
                        v-model="passageway.androidPort"
                      ></el-input>
                    </div>
                  </div>
                </el-collapse-item>
                <el-collapse-item title="出口安卓机" name="4">
                  <div class="c-i-marbot">
                    <div class="c-i-title">
                      安卓机IP：
                    </div>
                    <div>
                      <el-input
                        placeholder="请输入安卓IP"
                        class="ipt-width"
                        v-model="passageway.androidOutIp"
                      ></el-input>
                    </div>
                  </div>
                  <div class="c-i-marbot">
                    <div class="c-i-title">
                      安卓端口：
                    </div>
                    <div>
                      <el-input
                        placeholder="请输入安卓端口"
                        class="ipt-width"
                        v-model="passageway.androidOutPort"
                      ></el-input>
                    </div>
                  </div>
                </el-collapse-item>
                <el-collapse-item title="主机闸道" name="5">
                  <div class="c-i-marbot">
                    <div class="c-i-title">
                      闸道编码：
                    </div>
                    <div>
                      <el-select
                        class="ipt-width"
                        v-model="passageway.gatewaySerialNum"
                        placeholder="请输入从机闸道编码"
                        filterable
                        @change="changeGateway"
                      >
                        <el-option
                          v-for="(item, index) in hardwareListOption"
                          :key="index"
                          :value="item.gatewaySerialNum"
                          :label="item.gatewaySerialNum"
                          :disabled="item.flag"
                        >
                          <!-- gatewayNum -->
                          <span style="float: left">{{
                            item.gatewaySerialNum
                          }}</span>
                          <span
                            style="float: right; color: #8492a6; font-size: 13px"
                            >{{ item.gatewayNum }}</span
                          >
                        </el-option>
                      </el-select>
                    </div>
                  </div>
                  <div
                    v-if="
                      passageway.gatewayIp != '' && passageway.gatewayIp != null
                    "
                    class="c-i-marbot"
                  >
                    <div class="c-i-title">
                      闸道IP：
                    </div>
                    <div>
                      <el-input
                        class="ipt-width"
                        :disabled="true"
                        v-model="passageway.gatewayIp"
                      ></el-input>
                    </div>
                  </div>
                  <div
                    v-if="
                      passageway.gatewayPort != '' &&
                        passageway.gatewayPort != null
                    "
                    class="c-i-marbot"
                  >
                    <div class="c-i-title">
                      闸道端口：
                    </div>
                    <div>
                      <el-input
                        class="ipt-width"
                        :disabled="true"
                        v-model="passageway.gatewayPort"
                      ></el-input>
                    </div>
                  </div>
                </el-collapse-item>
                <el-collapse-item title="从机闸道" name="6">
                  <div class="c-i-marbot">
                    <div class="c-i-title">
                      闸道编码：
                    </div>
                    <div>
                      <el-select
                        class="ipt-width"
                        v-model="passageway.slaveGatewaySerialNum"
                        placeholder="请输入从机闸道编码"
                        filterable
                        @change="changeSlaveGateWay"
                      >
                        <el-option
                          v-for="(item, index) in hardwareListOption"
                          :key="index"
                          :value="item.gatewaySerialNum"
                          :label="item.gatewaySerialNum"
                          :disabled="item.flag"
                        >
                          <!-- gatewayNum -->
                          <span style="float: left">{{
                            item.gatewaySerialNum
                          }}</span>
                          <span
                            style="float: right; color: #8492a6; font-size: 13px"
                            >{{ item.gatewayNum }}</span
                          >
                        </el-option>
                      </el-select>
                    </div>
                  </div>
                  <div
                    v-if="
                      passageway.slaveGatewayIp != '' &&
                        passageway.slaveGatewayIp != null
                    "
                    class="c-i-marbot"
                  >
                    <div class="c-i-title">
                      闸道IP：
                    </div>
                    <div>
                      <el-input
                        class="ipt-width"
                        :disabled="true"
                        v-model="passageway.slaveGatewayIp"
                      ></el-input>
                    </div>
                  </div>
                  <div
                    v-if="
                      passageway.slaveGatewayPort != '' &&
                        passageway.slaveGatewayPort != null
                    "
                    class="c-i-marbot"
                  >
                    <div class="c-i-title">
                      闸道端口：
                    </div>
                    <div>
                      <el-input
                        class="ipt-width"
                        :disabled="true"
                        v-model="passageway.slaveGatewayPort"
                      ></el-input>
                    </div>
                  </div>
                </el-collapse-item>
              </el-collapse>
              <div class="set-channel-btn" v-if="addStatus || changeStatus">
                <el-button type="danger" @click="unAddOrUnChangeChannel()"
                  >取消</el-button
                >
                <el-button
                  type="primary"
                  v-if="addStatus"
                  @click="sureAddChannel()"
                  >确定添加</el-button
                >
                <el-button
                  type="warning"
                  v-if="changeStatus"
                  @click="sureChangeChannel()"
                  >确定修改</el-button
                >
              </div>
            </el-main>
          </el-container>
        </div>
        <!-- 规则设置 -->
        <div class="rule-set">
          <el-container>
            <h4>通道规则</h4>
            <el-header>
              <el-select v-model="drivewayRuleId" @change="getChannelRule">
                <el-option
                  v-for="(item, index) in allRuleList"
                  :value="item.drivewayRuleId"
                  :label="item.drivewayRuleName"
                  :key="index"
                ></el-option>
              </el-select>
              <el-button type="primary" @click="addRule()">添加规则</el-button>
              <el-button type="warning" @click="changeRule()"
                >修改规则</el-button
              >
              <el-button type="danger" @click="removeRule()"
                >删除规则</el-button
              >
            </el-header>
            <el-main>
              <el-row>
                <el-col :span="6">
                  规则名称：
                </el-col>
                <el-col :span="12">
                  <el-input
                    class="ipt-width"
                    placeholder="请输入规则名称"
                    v-model="reluData.drivewayRuleName"
                  ></el-input>
                </el-col>
              </el-row>
              <el-collapse
                v-model="activeReluName"
                accordion
                class="set-collapse"
              >
                <el-collapse-item title="入口通道规则" name="1">
                  <div class="r-i-marbot">
                    <div class="c-i-title">
                      星期选择：
                    </div>
                    <div class="checkbox-set">
                      <el-checkbox-group v-model="weekIn">
                        <el-checkbox
                          v-for="(week, index) in weekList"
                          :key="index"
                          :label="week"
                        ></el-checkbox>
                      </el-checkbox-group>
                    </div>
                  </div>
                  <div class="r-i-marbot">
                    <div class="c-i-title">
                      时间选择：
                    </div>
                    <div class="time-set">
                      <el-time-select
                        placeholder="起始时间"
                        v-model="reluData.startTimeIn"
                        :picker-options="{
                          start: '00:00',
                          step: '00:30',
                          end: '24:00'
                        }"
                      >
                      </el-time-select>
                      <el-time-select
                        placeholder="结束时间"
                        v-model="reluData.endTimeIn"
                        :picker-options="{
                          start: '00:00',
                          step: '00:30',
                          end: '24:00',
                          minTime: reluData.startTimeIn
                        }"
                      >
                      </el-time-select>
                    </div>
                  </div>
                  <div class="r-i-marbot">
                    <div class="c-i-title">
                      通行方式：
                    </div>
                    <div class="passtupe-set">
                      <el-radio-group v-model="reluData.drivewayOpenTypeIn">
                        <el-radio :label="1">自由通行</el-radio>
                        <el-radio :label="2">识别通行</el-radio>
                        <el-radio :label="3">禁止通行</el-radio>
                      </el-radio-group>
                    </div>
                  </div>
                </el-collapse-item>
                <el-collapse-item title="出口通道规则" name="2">
                  <div class="r-i-marbot">
                    <div class="c-i-title">
                      星期选择：
                    </div>
                    <div class="checkbox-set">
                      <el-checkbox-group v-model="weekOut">
                        <el-checkbox
                          v-for="(week, index) in weekList"
                          :key="index"
                          :label="week"
                        ></el-checkbox>
                      </el-checkbox-group>
                    </div>
                  </div>
                  <div class="r-i-marbot">
                    <div class="c-i-title">
                      时间选择：
                    </div>
                    <div class="item-label-right">
                      <el-time-select
                        placeholder="起始时间"
                        v-model="reluData.startTimeOut"
                        :picker-options="{
                          start: '00:00',
                          step: '00:30',
                          end: '24:00'
                        }"
                      >
                      </el-time-select>
                      <el-time-select
                        placeholder="结束时间"
                        v-model="reluData.endTimeOut"
                        :picker-options="{
                          start: '00:00',
                          step: '00:30',
                          end: '24:00',
                          minTime: reluData.startTimeOut
                        }"
                      >
                      </el-time-select>
                    </div>
                  </div>
                  <div class="r-i-marbot">
                    <div class="c-i-title">
                      通行方式：
                    </div>
                    <div class="item-label-right">
                      <el-radio-group v-model="reluData.drivewayOpenTypeOut">
                        <el-radio :label="1">自由通行</el-radio>
                        <el-radio :label="2">识别通行</el-radio>
                        <el-radio :label="3">禁止通行</el-radio>
                      </el-radio-group>
                    </div>
                  </div>
                </el-collapse-item>
              </el-collapse>
              <div
                class="set-channel-btn"
                v-if="addReluStatus || changeReluStatus"
              >
                <el-button
                  type="danger"
                  @click="addReluStatus = changeReluStatus = false"
                  >取消</el-button
                >
                <el-button
                  type="primary"
                  @click="sureAddRelu()"
                  v-if="addReluStatus"
                  >确定添加</el-button
                >
                <el-button
                  type="warning"
                  @click="sureChangeRelu()"
                  v-if="changeReluStatus"
                  >确定修改</el-button
                >
              </div>
            </el-main>
          </el-container>
        </div>
      </div>
    </el-main>
  </el-container>
</template>
<script>
import { mapGetters } from "vuex";
// import AsideTable from "../modules/aside-table";
export default {
  components: {
    // AsideTable
  },
  computed: {
    ...mapGetters(["userinfo"])
  },
  data() {
    return {
      tableData: [], //小区数据
      likeData: "", //模糊查询数据

      unitId: "", //小区ID
      channeloption: [], //通道列表
      value: "", //选中的通道
      activeName: "1", //默认点击项
      passageway: {
        drivewayName: "", //通道名称
        drivewayCode: "",
        cameraType: "", //相机类型
        cameraIp: "",
        cameraPort: "",
        cameraOutIp: "",
        cameraOutPort: "",
        androidIp: "",
        androidPort: "",
        androidOutIp: "",
        androidOutPort: "",
        gatewaySerialNum: "",
        gatewayIp: "",
        gatewayPort: "",
        slaveGatewaySerialNum: "",
        slaveGatewayIp: "",
        slaveGatewayPort: ""
      }, //通道数据
      hardwareListOption: [], //道闸数据列表
      addStatus: false, //添加通道状态
      changeStatus: false, //修改通道状态
      allRuleList: [], //规则列表
      drivewayRuleId: "", //当前选中的ruleID
      activeReluName: "1",
      weekList: [
        "星期一",
        "星期二",
        "星期三",
        "星期四",
        "星期五",
        "星期六",
        "星期日"
      ],
      weekIn: [],
      weekOut: [],
      reluData: {
        drivewayRuleName: "",
        weekIn: "",
        startTimeIn: "",
        endTimeIn: "",
        drivewayOpenTypeIn: 1,
        weekOut: "",
        startTimeOut: "",
        endTimeOut: "",
        drivewayOpenTypeOut: 1
      },
      addReluStatus: false,
      changeReluStatus: false
    };
  },
  created() {
    this.getHousingList();
  },
  mounted() {},
  methods: {
    // active(row) {
    //   this.unitId = row.userId;
    //   this.getChannelList();
    //   this.queryHardware();
    // },
    /*
     **  @description 获取小区数据
     **  @param {}
     **  @return
     **  @author shipingan
     */
    getHousingList() {
      let url = "/dapi/u/likeSelectUserInfo";
      let params = {
        uid: this.userinfo.uid,
        likeData: this.likeData
      };
      this.$axios.post(url, this.$qs.stringify(params)).then(res => {
        let data = res.data;
        if (data.status == 200) {
          this.tableData = [];
          data.data.map(item => {
            if (item.userRoleCode == 3 || item.userRoleCode == 9) {
              this.tableData.push(item);
            }

            if (item.users && item.users.length > 0) {
              let users = item.users.filter(
                k => k.userRoleCode == 3 || k.userRoleCode == 9
              );
              item.users = users;
              this.tableData.push(item);
            }
          });
          // this.$refs.tablesure.setCurrentRow(this.tableData[0]); //使用setCurrentRow必须要设置高亮当前行
          this.$nextTick(() => {
            this.$refs.tablesure.setCurrentRow(this.tableData[0]);
          });
          //点击第一项
          if (this.tableData[0].users) {
            if (
              this.tableData[0].users != "" &&
              this.tableData[0].users.length > 0
            ) {
              this.houseClick(this.tableData[0].users[0]);
              return;
            }
          }
          this.houseClick(this.tableData[0]);
        }
      });
    },
    houseClick(row) {
      this.unitId = row.userId;
      this.getChannelList();
      this.queryHardware();
    },
    /*
     **  @description 获取通道列表
     **  @param {}
     **  @return
     **  @author shipingan
     */
    getChannelList() {
      let url = "/dapi/dri/selectDrivewayByUnitId";
      let params = {
        unitId: this.unitId
      };
      this.$axios.post(url, this.$qs.stringify(params)).then(res => {
        let data = res.data;
        if (data.status == 200) {
          this.channeloption = data.data;
          if (this.channeloption.length > 0) {
            //查询到不为空，渲染第一条数据
            let obj = this.channeloption[0];
            this.value = obj.drivewayId;
            this.getDrivewayInfo();
          } else {
            this.value = "";
            Object.assign(
              this.$data.passageway,
              this.$options.data().passageway
            );
          }
        }
      });
    },
    /*
     **  @description 获取通道详情
     **  @param {}
     **  @return
     **  @author shipingan
     */
    getDrivewayInfo() {
      let url = "/dapi/dri/selectDrivewayInfoById";
      let params = {
        drivewayId: this.value
      };
      this.$axios.post(url, this.$qs.stringify(params)).then(res => {
        let data = res.data;
        if (data.status == 200) {
          let obj = data.data;
          this.passageway = { ...obj };
          this.getRuleList();
        } else {
          this.$message.error(data.message);
        }
      });
    },
    /*
     **  @description 获取通道规则
     **  @param {}
     **  @return
     **  @author shipingan
     */
    getRuleList() {
      let url = "/dapi/dri/selectDrivewayRule";
      let params = {
        drivewayId: this.value
      };
      this.$axios.post(url, this.$qs.stringify(params)).then(res => {
        this.tags = [];
        let data = res.data;
        if (data.status == 200) {
          this.allRuleList = data.data;
          if (this.allRuleList.length > 0) {
            this.drivewayRuleId = this.allRuleList[0].drivewayRuleId;
            this.queryRuleDetalis(this.drivewayRuleId);
          } else {
            this.drivewayRuleId = "";
            this.weekIn = [];
            this.weekOut = [];
            Object.assign(this.$data.reluData, this.$options.data().reluData);
          }
        } else {
          this.$message.error(data.message);
        }
      });
    },
    /*
     **  @description 查询区域硬件码
     **  @param {}
     **  @return
     **  @author shipingan
     */
    queryHardware() {
      let url = "/dapi/dri/getGatewayListByUnitId";
      let params = {
        isUnitId: this.unitId
      };
      this.$axios
        .post(url, this.$qs.stringify(params))
        .then(res => {
          let data = res.data;
          if (data.status == 200) {
            if (data.data.length > 0) {
              let obj = {
                gatewaySerialNum: "闸道编码",
                gatewayNum: "通道号",
                flag: true
              };
              this.hardwareListOption = data.data;
              this.hardwareListOption.unshift(obj);
            } else {
              this.hardwareListOption = [];
            }
          } else {
            this.hardwareListOption = [];
            this.$message.error(data.message);
          }
        })
        .catch(() => {
          this.hardwareListOption = [];
          this.$message.error("获取硬件板服务器异常");
        });
    },
    /*
     **  @description 选中的设备号
     **  @param {}
     **  @return
     **  @author shipingan
     */
    changeGateway(value) {
      let obj = this.hardwareListOption.find(d => d.gatewaySerialNum == value);
      this.passageway.gatewayIp = obj.gatewayIp;
      this.passageway.gatewayPort = obj.gatewayPort;
    },
    changeSlaveGateWay(value) {
      let obj = this.hardwareListOption.find(d => d.gatewaySerialNum == value);
      this.passageway.slaveGatewayIp = obj.gatewayIp;
      this.passageway.slaveGatewayPort = obj.gatewayPort;
    },
    /*
     **  @description 添加通道
     **  @param {}
     **  @return
     **  @author shipingan
     */
    addChannel() {
      Object.assign(this.$data.passageway, this.$options.data().passageway);
      this.changeStatus = false;
      this.addStatus = true;
    },
    sureAddChannel() {
      this.passageway.uid = this.userinfo.uid;
      this.passageway.isUnitId = this.unitId;

      let url = "/dapi/dri/saveDrivewayInfo";
      let params = {
        ...this.passageway
      };
      if (this.passageway.drivewayName == "") {
        this.$message.error("请输入通道名称");
        return;
      }
      if (this.passageway.drivewayCode == "") {
        this.$message.error("请输入通道编码");
        return;
      }

      this.$axios.post(url, this.$qs.stringify(params)).then(res => {
        let data = res.data;
        if (data.status == 200) {
          this.$message({
            message: data.message,
            type: "success"
          });
          this.getChannelList();
          this.addStatus = false;
        } else {
          this.$message.error("上传失败");
        }
      });
    },
    changeChannel() {
      this.unAddOrUnChangeChannel();
      this.changeStatus = true;
    },
    sureChangeChannel() {
      let url = "/dapi/dri/updateDrivewayInfo";
      this.passageway.drivewayId = this.value;
      let params = { ...this.passageway };
      if (this.passageway.drivewayName == "") {
        this.$message.error("请输入通道名称");
        return;
      }
      if (this.passageway.drivewayCode == "") {
        this.$message.error("请输入通道编码");
        return;
      }
      this.$axios.post(url, this.$qs.stringify(params)).then(res => {
        let data = res.data;
        if (data.status == 200) {
          this.$message({
            message: data.message,
            type: "success"
          });
          this.getChannelList();
          this.changeStatus = false;
        } else {
          this.$message.error(data.message);
        }
      });
    },
    removeChannel() {
      this.$confirm("确定删除选中通道吗？", "确认提示", {
        distinguishCancelAndClose: true,
        confirmButtonText: "确定删除",
        cancelButtonText: "放弃删除"
      })
        .then(() => {
          let url = "/dapi/dri/deleteDrivewayById";
          let params = {
            drivewayId: this.value
          };
          this.$axios.post(url, this.$qs.stringify(params)).then(res => {
            let data = res.data;
            if (data.status == 200) {
              this.$message({
                type: "success",
                message: "删除成功"
              });
              this.getChannelList();
            } else {
              this.$message.error("删除失败");
            }
          });
        })
        .catch(action => {
          this.$message({
            type: "info",
            message: "放弃删除"
          });
        });
    },
    /*
     **  @description 取消事件
     **  @param {}
     **  @return
     **  @author shipingan
     */
    unAddOrUnChangeChannel() {
      this.addStatus = false;
      this.changeStatus = false;
      this.getDrivewayInfo();
    },
    /*
     **  @description 添加规则
     **  @param {}
     **  @return
     **  @author shipingan
     */
    addRule() {
      Object.assign(this.$data.reluData, this.$options.data().reluData);
      this.weekIn = [];
      this.weekOut = [];
      this.changeReluStatus = false;
      this.addReluStatus = true;
    },
    sureAddRelu() {
      let flag = this.isHasTimerSet();
      if (flag) {
        this.$message.error("您设置的时间阶段已被设置！");
        return;
      }
      let url = "/dapi/dri/saveDrivewayRule";
      this.reluData.uid = this.userinfo.uid;
      this.reluData.drivewayId = this.value;
      this.reluData.isUnitId = this.unitId;
      this.reluData.weekIn = JSON.stringify(this.weekIn);
      this.reluData.weekOut = JSON.stringify(this.weekOut);
      let params = { ...this.reluData };
      if (params.drivewayRuleName == "") {
        this.$message.error("请输入规则名称！");
        return;
      }
      this.$axios.post(url, this.$qs.stringify(params)).then(res => {
        let data = res.data;
        if (data.status == 200) {
          this.$message({
            message: data.message,
            type: "success"
          });
          this.addReluStatus = false;
          //添加成功
          this.getRuleList();
        } else {
          this.$message.error(data.message);
        }
      });
    },
    changeRule() {
      if (this.drivewayRuleId == "") {
        this.$message.error("没有可修改的规则！");
        return;
      }
      this.queryRuleDetalis(this.drivewayRuleId);
      this.changeReluStatus = true;
    },
    sureChangeRelu() {
      let flag = this.isHasTimerSet(this.drivewayRuleId);
      if (flag) {
        this.$message.error("您设置的时间阶段已被设置！");
        return;
      }
      this.reluData.weekIn = JSON.stringify(this.weekIn);
      this.reluData.weekOut = JSON.stringify(this.weekOut);
      this.reluData.drivewayId = this.value;
      this.reluData.isUnitId = this.unitId;
      let url = "/dapi/dri/updateDrivewayRule";
      let params = { ...this.reluData };
      if (params.drivewayRuleName == "") {
        this.$message.error("请输入规则名称！");
        return;
      }
      this.$axios.post(url, this.$qs.stringify(params)).then(res => {
        let data = res.data;
        if (data.status == 200) {
          this.$message({
            message: "修改成功",
            type: "success"
          });
          //修改成功
          this.changeReluStatus = false;
          this.getRuleList();
        } else {
          this.$message.error(data.message);
        }
      });
    },
    /*
     **  @description 判断时间交集
     **  @param {}
     **  @return
     **  @author shipingan
     */
    isHasTimerSet(changRuleId = null) {
      let RuL;
      if (changRuleId) {
        RuL = this.allRuleList.filter(d => d.drivewayRuleId != changRuleId);
      } else {
        RuL = this.allRuleList;
      }
      let flag = false;
      if (this.allRuleList != []) {
        //判断每一条数据是否存在交集//
        flag = RuL.some(item => {
          //入口
          let result = false;
          if (
            !(
              item.startTimeIn >= this.reluData.endTimeIn ||
              item.endTimeIn <= this.reluData.startTimeIn
            )
          ) {
            //时间冲突--判断日期
            result = JSON.parse(item.weekIn).some(wIn => {
              return this.weekIn.includes(wIn);
            });
            if (result) {
              return result;
            }
          }
          //出口
          if (
            !(
              item.startTimeOut >= this.reluData.endTimeOut ||
              item.endTimeOut <= this.reluData.startTimeOut
            )
          ) {
            //时间冲突--判断日期
            result = JSON.parse(item.weekOut).some(wOut => {
              return this.weekIn.includes(wOut);
            });
            if (result) {
              return result;
            }
          }
        });
        return flag;
      }
    },
    /*
     **  @description 选中规则
     **  @param {}
     **  @return
     **  @author shipingan
     */
    getChannelRule(value) {
      this.queryRuleDetalis(value);
    },
    /*
     **  @description 查询规则详情
     **  @param {}
     **  @return
     **  @author shipingan
     */
    queryRuleDetalis(ruleId) {
      this.changeReluStatus = this.addReluStatus = false;
      let obj = this.allRuleList.find(d => d.drivewayRuleId == ruleId);
      this.reluData = { ...obj };
      this.weekIn = JSON.parse(obj.weekIn);
      this.weekOut = JSON.parse(obj.weekOut);
    },
    /*
     **  @description 删除规则
     **  @param {}
     **  @return
     **  @author shipingan
     */
    removeRule() {
      this.$confirm("确认删除？", "确认信息", {
        distinguishCancelAndClose: true,
        confirmButtonText: "确定删除",
        cancelButtonText: "放弃删除"
      })
        .then(() => {
          let url = "/dapi/dri/deleteDrivewayRule";
          let params = {
            drivewayRuleId: this.drivewayRuleId,
            drivewayId: this.value
          };
          this.$axios.post(url, this.$qs.stringify(params)).then(res => {
            let data = res.data;
            if (data.status == 200) {
              this.$message({
                message: "删除成功",
                type: "success"
              });
              this.getRuleList();
            } else {
              this.$message.error(data.message);
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "取消删除"
          });
        });
    }
  }
};
</script>
<style lang="less" scoped>
@box-shadow: 0 0 10px #ccc;
.el-aside {
  box-shadow: @box-shadow;
  .el-header {
    display: flex;
    box-sizing: border-box;
    padding: 16px 20px;
    justify-content: space-between;
    box-shadow: @box-shadow;
    .el-input {
      width: 180px;
    }
  }
  .aside-main {
    .hardware-btn {
      width: 100%;
      margin-bottom: 2px;
    }
    padding-top: 10px;
  }
}
.channel-set-main {
  padding: 0 20px;
  h3 {
    text-align: left;
  }
  .set-channel-relu {
    display: flex;
    .channel-set {
      .el-container {
        padding: 20px 0;
        box-shadow: @box-shadow;
        h4 {
          margin-top: 0;
        }
        .el-header {
          text-align: left;
          .el-select {
            margin-right: 10px;
          }
        }
        .el-main {
          padding: 10px 20px;
          .ipt-width {
            width: 200px;
          }
          .el-row {
            padding: 10px;
            box-shadow: @box-shadow;
            margin-bottom: 10px;
          }
          .el-collapse {
            .el-collapse-item {
              .c-i-marbot {
                display: flex;
                justify-content: center;
                margin-bottom: 10px;
                .c-i-title {
                  width: 100px;
                }
              }
              .r-i-marbot {
                .c-i-marbot;
                justify-content: flex-start;
              }
            }
          }
          .set-channel-btn {
            margin-top: 20px;
          }
        }
      }
    }
    .rule-set {
      .channel-set;
      margin-left: 20px;
    }
  }

  /deep/ .el-collapse-item__header {
    font-size: 16px;
    color: #67c23a;
  }
}
</style>
